// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/business/app/css/" + chunkId + "." + {"192":"99c5910abca58949","221":"baf7c471febdc206","641":"b335dce5d4086df7","963":"0e69ae3fd3dffa4f","974":"873e3fd623b0a6b2","984":"74fd30cb53c4095a"}[chunkId] + ".css";
};